React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'VisibilityComponent'

  render: t.renderable ->
    { visibility } = @props

    t.div '.setting-item-detail', ->
      t.div '.markeddown', ->
        if visibility is undefined
          t.format 'let-team-admins-decide'
        else
          helperText = l(['ent orgPrefs', 'visibility', visibility])
          switch visibility
            when 'public'
              t.p ->
                t.icon 'public'
                t.format 'public-helpertext', { helperText }
            when 'private'
              t.p ->
                t.icon 'private'
                t.format 'private-helpertext', { helperText }
            else
              throw new Error("Unrecognized visibility setting: #{ visibility }")



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/visibility-component.coffee